module.exports = __webpack_public_path__ + "img/Website background image roses.ac0e4d5f.png";